import "./helpers/installFrontendErrorReporting";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App.js";
import store from "./redux-store/store";
import { Provider } from "react-redux";
/** @jsx jsx */
import { jsx, ThemeProvider } from "@emotion/react";
import theme from "./styles/theme";
import ErrorBoundary from "./comps/ErrorBoundary";
const modalRoot = document.getElementById("navbar-root");
const portalProps = Object.assign({}, modalRoot?.dataset);
if (module.hot) {
    module.hot.accept();
}
ReactDOM.render(
    <ErrorBoundary>
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <App {...portalProps} />
            </ThemeProvider>
        </Provider>
    </ErrorBoundary>,
    document.getElementById("application"),
);
